import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { getDownloadURL, getStorage, ref, uploadString } from '@angular/fire/storage';

import { LoaderService } from '../util/loader.service';


@Injectable({
  providedIn: 'root',
})
export class FdbService {

  operator: any[] = ['array-contains-any', '==', 'not-in', 'in', 'array-contains', '!=', '<', '<=', '>', '>='];

  constructor(
    private loader: LoaderService,
    private firestore: Firestore, //this is important don't delete
  ) {
  }

  uploadAnyFile(base64: string, fileNameWithPath: string, contentType: string) {
    console.log(' upload file : ' + fileNameWithPath);
    const storage = getStorage();
    const storageRef = ref(storage, fileNameWithPath);
    this.loader.show();
    return uploadString(storageRef, base64, 'base64', { contentType: contentType })
      .then((snapshot) => {
        this.loader.hide();
        return getDownloadURL(ref(storage, fileNameWithPath))
      });
  }

}
